import { SVGPropsIcon } from 'src/types';

export const SearchIcon = (props: SVGPropsIcon) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1136 2C8.50888 2 6.9402 2.47585 5.60593 3.36739C4.27165 4.25892 3.23171 5.52609 2.61761 7.00866C2.00352 8.49122 1.84284 10.1226 2.1559 11.6965C2.46897 13.2704 3.24171 14.7161 4.37642 15.8508C5.51113 16.9855 6.95683 17.7582 8.53071 18.0713C10.1046 18.3844 11.736 18.2237 13.2185 17.6096C13.974 17.2967 14.6735 16.8732 15.2959 16.3565L20.2197 21.2803C20.5126 21.5732 20.9874 21.5732 21.2803 21.2803C21.5732 20.9874 21.5732 20.5126 21.2803 20.2197L16.3565 15.2959C16.5353 15.0805 16.7033 14.8554 16.8598 14.6213C17.7513 13.287 18.2272 11.7183 18.2272 10.1135C18.2271 7.96174 17.3722 5.89811 15.8506 4.37655C14.3291 2.855 12.2654 2.00014 10.1136 2ZM16.6652 11.0172C16.7819 10.1779 16.7382 9.30203 16.5097 8.4312C15.5832 4.89959 11.9691 2.78776 8.43752 3.71431C7.11841 4.06039 5.99738 4.78141 5.15878 5.73302C4.67653 6.2785 4.28505 6.90281 4.00343 7.58268C3.50287 8.79116 3.3719 10.1209 3.62708 11.4038C3.88227 12.6868 4.51215 13.8652 5.43708 14.7901C6.36201 15.715 7.54044 16.3449 8.82335 16.6001C10.1063 16.8553 11.436 16.7243 12.6445 16.2238C13.853 15.7232 14.8859 14.8755 15.6126 13.7879C16.1707 12.9526 16.529 12.0046 16.6652 11.0172Z"
        fill="white"
      />
    </svg>
  );
};
